var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "swiper-container quotes-carousel row-c-lg" },
    [
      _c(
        "div",
        { staticClass: "swiper-wrapper quotes-carousel__slides-wrapper" },
        _vm._l(_vm.slides, function(slide, index) {
          return _c("div", {
            key: index,
            staticClass: "swiper-slide quotes-slide",
            domProps: { innerHTML: _vm._s(slide) }
          })
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "quotes-carousel__pagination" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }